import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

export const UpcomingTrainings = () => {
  const { language } = useLanguage();

  const trainings = language === 'fr' ? [
  { date: 'Mars 2026', title: 'Introduction à l\'IA générative juridique', format: 'Webinaire · 2h', spots: 'Places limitées', slug: 'ia-generative-juridique' },
  { date: 'Mars 2026', title: 'Prompt engineering juridique avancé', format: 'Webinaire · 2h', spots: 'Places limitées', slug: 'prompt-engineering-juridique' },
  { date: 'Avril 2026', title: 'Sécurité & déontologie de l\'IA', format: 'Webinaire · 2h', spots: 'Places limitées', slug: 'securite-deontologie-ia' }] :
  [
  { date: 'March 2026', title: 'Introduction to Legal Generative AI', format: 'Webinar · 2h', spots: 'Limited seats', slug: 'intro-legal-generative-ai' },
  { date: 'March 2026', title: 'Advanced Legal Prompt Engineering', format: 'Webinar · 2h', spots: 'Limited seats', slug: 'advanced-legal-prompt-engineering' },
  { date: 'April 2026', title: 'AI Security & Ethics', format: 'Webinar · 2h', spots: 'Limited seats', slug: 'ai-security-ethics' }];


  const basePath = language === 'fr' ? '/reservation-webinaire' : '/book-webinar';

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-0 py-[20px] rounded-2xl bg-primary">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <CalendarDays className="w-5 h-5 text-primary" />
          </div>
          <h2 className="text-2xl lg:text-3xl font-bold text-primary-foreground">
            {language === 'fr' ? 'Prochaines formations IA pour juristes' : 'Upcoming Legal AI Training Sessions'}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {trainings.map((training, index) =>
          <Link
            key={index}
            to={`${basePath}/${training.slug}`}
            className="bg-card border rounded-xl p-5 hover:shadow-md transition-all duration-300 block border-primary">

              <div className="flex items-center gap-2 mb-2">
                <CalendarDays className="w-4 h-4 text-primary" />
                <span className="text-sm font-semibold text-primary">{training.date}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground mb-2 leading-snug">
                {training.title}
              </h3>
              <div className="flex items-center justify-between text-sm text-muted-foreground">
                <span>{training.format}</span>
                <span className="text-xs font-medium text-accent">{training.spots}</span>
              </div>
              <div className="mt-3 flex items-center text-sm text-primary font-medium">
                {language === 'fr' ? 'S\'inscrire' : 'Register'}
                <ArrowRight className="w-4 h-4 ml-1" />
              </div>
            </Link>
          )}
        </div>

        <div className="text-center">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90">
            <Link to="/formation-ia-juridique-eligible-financement" className="flex items-center gap-2">
              {language === 'fr' ? 'Voir toutes les formations éligibles' : 'View all eligible trainings'}
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>);

};